import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { FiLogOut } from "react-icons/fi";
import "./NavBar.css";


const NavBar = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const { user, isAdmin, isAssistant,isSuperAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_COMPLAINTS_APP_BE_URL;
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/complaints-website");
    setIsNavbarOpen(false); // close navbar after logout
  };

  // Opens the confirmation modal instead of logging out immediately
  const requestLogout = () => {

    setShowLogoutConfirm(true);
  };

  // Confirms logout from the modal
  const confirmLogout = async () => {
    setShowLogoutConfirm(false);
    await handleLogout();
  };

  // Cancels the logout confirmation
  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };


  // Close dropdown when clicked outside
  

  // Close logout confirm modal on Escape key
  useEffect(() => {
    if (!showLogoutConfirm) return;
    const handleEsc = (event) => {
      if (event.key === "Escape") setShowLogoutConfirm(false);
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [showLogoutConfirm]);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        <div
          className="logo text-white"
          onClick={() => {
            navigate("/complaints-website");
            setIsNavbarOpen(false);
          }}
        >
          THRIVE
        </div>
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsNavbarOpen((prev) => !prev)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`} id="navbarNav">
          <ul className="navbar-nav ms-auto mb-lg-0">
            {user && (
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/all-complaints"
                  onClick={() => setIsNavbarOpen(false)}
                >
                  All Complaints
                </NavLink>
              </li>
            )}
            {user && !isAdmin && !isAssistant && (
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/user-analysis"
                  state={{ email: user.email }}
                  onClick={() => setIsNavbarOpen(false)}
                >
                  Dashboard
                </NavLink>
              </li>
            )}


            {user && (
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/my-complaints"
                  state={{ email: user.email }}
                  onClick={() => setIsNavbarOpen(false)}
                >
                  My Requests
                </NavLink>
              </li>
            )}

            {(isAdmin || isAssistant) && (
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/adminpage"
                  onClick={() => setIsNavbarOpen(false)}
                >
                  Resolve
                </NavLink>
              </li>
            )}
            {isSuperAdmin && (
              <li className="nav-item">
                <NavLink className="nav-link" to="/superadmin-dashboard" onClick={() => setIsNavbarOpen(false)}>
                  SuperAdmin
                </NavLink>
              </li>
            )}

            {(user || isAdmin) ? (
              
              <li
  className="nav-item d-flex align-items-center"
  style={{ marginLeft: "12px" }}
>
  <button
    className="logout-icon-btn"
    onClick={requestLogout}
    title="Logout"
    aria-label="Logout"
  >
    <FiLogOut size={22} />
  </button>
</li>
            ) : (
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/complaints-website"
                  onClick={() => setIsNavbarOpen(false)}
                >
                  Login
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </div>

      {/* ✅ Logout Confirmation Modal — renders above the navbar */}
      {showLogoutConfirm && (
        <div className="logout-modal-overlay" onClick={cancelLogout}>
          <div
            className="logout-modal-card"
            role="dialog"
            aria-modal="true"
            aria-labelledby="logout-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <h4 id="logout-modal-title" className="logout-modal-title">Logout</h4>
            <p className="logout-modal-text">Are you sure you want to log out?</p>

            <button className="logout-modal-confirm-btn" onClick={confirmLogout}>
              Log out
            </button>
            <button className="logout-modal-cancel-btn" onClick={cancelLogout}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavBar;